import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import About from "../components/About";
import Features from "../components/Features";

const AboutUsPage = () => {
  return (
    <>
      <Header />
      <section className="section project" aria-labelledby="project-label">
        <About />
        <Features />
      </section>
      <Footer />
    </>
  );
};

export default AboutUsPage;
